<template>
  <div class="home">
    <div class="mt-4 p-5 bg-primary text-white rounded">
      <h1>Loading...</h1>
      <p>{{ message }}</p>
      <div class="progress">
        <div class="progress-bar progress-bar-striped" :style="{ width: progress }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseDataService } from "@/services/baseData.service";
import router from '@/router/index' 
export default {
  name: "HomeView",
  components: {},
  data() {
    return {
      progress: "0%",
      message:""
    };
  },
  mounted() {
    this.progress = "0%";
    baseDataService.menu().then((menu) => {
      try {
        var obj = JSON.parse(menu);
      }
      catch (e) {
        router.push("/login");
        return;
      }
      this.progress = "10%";
      this.$store.dispatch("auth/menu", menu).then(() => {
        this.progress = "20%";
        this.$store.dispatch("products/list").then(() => {
          this.progress = "100%";
          router.push("/");
        });
      });
    });
  },
};
</script>
